/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.academy.gen.ai.skills.rpc.IndustryUseCaseRpc
 */
import * as References from './IndustryUseCaseRpc';
import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { registerQuery, registerMutation } from 'data-fetching-client/next';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.academy.gen.ai.skills.rpc.IndustryUseCaseRpc#asyncBulkGenerateIndustryUseCase
 */
export const ASYNC_BULK_GENERATE_INDUSTRY_USE_CASE_MUTATION_FIELD_NAME = 'com_hubspot_academy_gen_ai_skills_rpc_IndustryUseCaseRpc_asyncBulkGenerateIndustryUseCase';
export const ASYNC_BULK_GENERATE_INDUSTRY_USE_CASE_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: ASYNC_BULK_GENERATE_INDUSTRY_USE_CASE_MUTATION_FIELD_NAME,
  args: ['videos'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.asyncBulkGenerateIndustryUseCaseRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.academy.gen.ai.skills.rpc.IndustryUseCaseRpc#asyncBulkGetIndustryUseCase
 */
export const ASYNC_BULK_GET_INDUSTRY_USE_CASE_QUERY_FIELD_NAME = 'com_hubspot_academy_gen_ai_skills_rpc_IndustryUseCaseRpc_asyncBulkGetIndustryUseCase';
export const ASYNC_BULK_GET_INDUSTRY_USE_CASE_QUERY = /* #__PURE__ */registerQuery({
  fieldName: ASYNC_BULK_GET_INDUSTRY_USE_CASE_QUERY_FIELD_NAME,
  args: ['taskIds'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.asyncBulkGetIndustryUseCaseRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});